<template>
    <transition
        name="fade"
        appear
        :css="false"
        @enter="enter"
    >
        <div class="sorting-puzzle">
            <div
                v-for="(item, index) in items"
                :key="index"
                class="items"
            >
                <div class="piece-1">
                    <span v-html="item[0]" />
                    <div ref="dropzones" class="dropzone" />
                </div>
                <div
                    ref="sortables"
                    class="piece-2"
                    :class="[blockedIndices.includes(index) && 'correct']"
                >
                    {{ items[sortKeys[index] || 0][1] }}
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import SlideState from '@/mixins/SlideState';
import Sortable from '@/mixins/Sortable';

export default {
    name: 'SortingPuzzle',
    mixins: [Sortable, SlideState],
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    data()
    {
        return {
            shuffleSortItems: true,
            sortItemCount: this.items.length
        };
    },
    created()
    {
        if (this.getState())
        {
            this.sortKeys.sort().forEach(key => this.blockedIndices.push(key));
        }
    },
    methods: {
        dropHandler(evt)
        {
            const {draggable, index} = evt;
            const dropzone = this.$refs.dropzones[index];

            if (draggable.hitTest(dropzone, '70%') && evt.sortKey === index)
            {
                evt.toVars.left = '-2.6vw';
                evt.correct = true;
            }
        },
        sortingCompleteHandler(evt)
        {
            if (evt.correct && evt.sortKey === evt.index)
            {
                this.$audioController.play('positive', {volume: 0.5});
                this.blockSortable(evt.index);
                if (this.blockedIndices.length === this.sortKeys.length)
                {
                    this.saveState(true);
                    this.$emit('finished');
                }
            }
        },
        enter(el, done)
        {
            // wenn v-show verwendet wird, setzen wir visibility auf hidden, damit Element trotzdem
            // den Platz einnimmt
            const {style} = el;
            if (style.display === 'none')
            {
                done();
                style.visibility = 'hidden';
                style.display = '';
                return;
            }
            if (style.visibility === 'hidden')
            {
                style.visibility = '';
            }
            this.$nextTick(() =>
            {
                style.opacity = 1;
            });
        }
    }
};
</script>

<style lang="scss" src="./SortingPuzzle.scss" />

